import { useAppSelector } from 'src/app/reduxCustomHooks';
import type { DemoAuthUser } from './useDemoAuthBootstrap';

export const useIsDemoUser = () =>
  useAppSelector((state) => {
    const user = state.auth.user as DemoAuthUser | null;

    return user?.accountTier === 'DEMO' || Boolean(user?.demo);
  });
